import { render, staticRenderFns } from "./coberturasEditablesComparador.vue?vue&type=template&id=6325720a"
import script from "./coberturasEditablesComparador.vue?vue&type=script&lang=js"
export * from "./coberturasEditablesComparador.vue?vue&type=script&lang=js"
import style0 from "./coberturasEditablesComparador.vue?vue&type=style&index=0&id=6325720a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VRow,VSelect})
